// tslint:disable max-line-length triple-equals prefer-for-of
import { setItem } from '../../utils/localStorage';
import moment from 'moment';
import { getComparedToAverageClassStyle } from '../../helpers/getComparedToAverageStyle';
import { reverse } from 'lodash';
import {
  CreateDataByIndexedDB,
  GetAllDataByIndexedDB,
} from '../../indexed/index';
import axiosInstance from '../../helpers/interceptor';
import { userHotelDetails } from '../../helpers/handleBrandAndHotelData';
import { ICustomScoresResponse } from '../../app/@types/customScores';
import { AssessmentTypes } from '../../app/@types/genericTypes';

export const trendingScores = async () => {
  const { selectedHotel } = userHotelDetails();
  let dataD: any = [];
  const OfflineData = await GetAllDataByIndexedDB(
    `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/trending-scores/0?`,
    selectedHotel
  );
  if (OfflineData) {
    dataD = OfflineData;
  } else {
    const { data } = await axiosInstance.get(
      `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/trending-scores/0?`
    );
    dataD = data;
    CreateDataByIndexedDB(
      `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/trending-scores/0?`,
      data,
      selectedHotel
    );
  }
  const { scores, average } = dataD;
  const trends = scores.map((score) => {
    return {
      name: moment(score.assessmentDate).format('DD/MMM/YY'),
      val: score.score,
      lineVal: score.rank,
      intent: getComparedToAverageClassStyle(score.score - average),
    };
  });
  return trends;
};

export const overallScore = async (selectedAssessment, selectedCompset) => {
  const { userData, selectedHotel, selectedBrand } = userHotelDetails();
  let apiUrl = `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/overall-score?&brandId=${selectedBrand}&toDate=${selectedAssessment}&isClientApp=true`;
  if (selectedCompset !== '0') {
    apiUrl += `&compSetNumber=${selectedCompset}`;
  }
  if (
    userData &&
    userData.user &&
    userData.user.userType &&
    userData.user.userType === 'subDepartment'
  ) {
    apiUrl += '&isDepartment=true';
  }
  let dataD: any = [];
  const OfflineData = await GetAllDataByIndexedDB(apiUrl, selectedHotel);
  if (OfflineData) {
    dataD = OfflineData;
  } else {
    const { data } = await axiosInstance.get(apiUrl);
    dataD = data;
    CreateDataByIndexedDB(apiUrl, data, selectedHotel);
  }

  return dataD;
};

export const overallEqScore = async (selectedAssessment, selectedCompset) => {
  const { selectedHotel, selectedBrand } = userHotelDetails();
  let compSet = '';
  if (selectedCompset !== '0') {
    compSet = `&compSetNumber=${selectedCompset}`;
  }
  let dataD: any = [];
  const OfflineData = await GetAllDataByIndexedDB(
    `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/overall-eq-score?&brandId=${selectedBrand}&toDate=${selectedAssessment}${compSet}&isClientApp=true`,
    selectedHotel
  );
  if (OfflineData) {
    dataD = OfflineData;
  } else {
    const { data } = await axiosInstance.get(
      `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/overall-eq-score?&brandId=${selectedBrand}&toDate=${selectedAssessment}${compSet}&isClientApp=true`
    );
    dataD = data;
    CreateDataByIndexedDB(
      `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/overall-eq-score?&brandId=${selectedBrand}&toDate=${selectedAssessment}${compSet}&isClientApp=true`,
      data,
      selectedHotel
    );
  }
  return dataD;
};

export const overallCustomScore = async (selectedAssessment) => {
  try {
    const { selectedHotel, selectedBrand } = userHotelDetails();
    let dataD: any = [];
    const OfflineData = await GetAllDataByIndexedDB(
      `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/overall-custom-scores?&brandId=${selectedBrand}&toDate=${selectedAssessment}&isClientApp=true`,
      selectedHotel
    );
    if (OfflineData) {
      dataD = OfflineData;
    } else {
      const { data } = await axiosInstance.get(
        `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/overall-custom-score?&brandId=${selectedBrand}&toDate=${selectedAssessment}&isClientApp=true`
      );
      dataD = data;
      CreateDataByIndexedDB(
        `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/overall-custom-score?&brandId=${selectedBrand}&toDate=${selectedAssessment}&isClientApp=true`,
        data,
        selectedHotel
      );
    }
    return dataD;
  } catch (err: any) {
    if (
      err &&
      err.response &&
      err.response.data &&
      err.response.data.statusCode === 400
    ) {
      return [];
    }
  }
};

export const getImproveOpportunities = async (selectedAssessment) => {
  const { selectedHotel } = userHotelDetails();
  let dataD: any = [];
  const OfflineData = await GetAllDataByIndexedDB(
    `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/improvement-opportunities?&scoreType=0&toDate=${selectedAssessment}&isClientApp=true`,
    selectedHotel
  );
  if (OfflineData) {
    dataD = OfflineData;
  } else {
    const { data } = await axiosInstance.get(
      `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/improvement-opportunities?&scoreType=0&toDate=${selectedAssessment}&isClientApp=true`
    );
    dataD = data;
    CreateDataByIndexedDB(
      `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/improvement-opportunities?&scoreType=0&toDate=${selectedAssessment}&isClientApp=true`,
      data,
      selectedHotel
    );
  }
  return dataD;
};

export const hotelBenchMarking = async (
  assessments,
  selectedAssessment,
  setBenchmarkingScores,
  benchmarkingScores,
  setSliderLoader,
  performanceClassification?: string
) => {
  const { selectedHotel, selectedBrand } = userHotelDetails();
  if (performanceClassification && performanceClassification === 'all') {
    performanceClassification = undefined;
  }
  const response: any[] = [];
  const d = [...benchmarkingScores];
  const assD = [...assessments];
  reverse(assD);
  setSliderLoader(true);
  const currAssess = assD.find((o) => o.stayStart === selectedAssessment);
  const filterAssess = assD.filter((o) => o.stayStart != selectedAssessment);
  let dataD: any = [];
  const OfflineData = await GetAllDataByIndexedDB(
    `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/benchmark-by-category?&brandId=${selectedBrand}&toDate=${currAssess.stayStart}&isClientApp=true${performanceClassification ? '&performanceClassifier=' + performanceClassification : ''}`,
    selectedHotel
  );
  if (OfflineData) {
    dataD = OfflineData;
  } else {
    const { data } = await axiosInstance.get(
      `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/benchmark-by-category?&brandId=${selectedBrand}&toDate=${currAssess.stayStart}&isClientApp=true${performanceClassification ? '&performanceClassifier=' + performanceClassification : ''}`
    );
    dataD = data;
    CreateDataByIndexedDB(
      `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/benchmark-by-category?&brandId=${selectedBrand}&toDate=${currAssess.stayStart}&isClientApp=true${performanceClassification ? '&performanceClassifier=' + performanceClassification : ''}`,
      data,
      selectedHotel
    );
  }

  const { scores } = dataD;
  const trends = scores.map((score) => {
    return {
      name: score.categoryName,
      val: score.score,
      lineVal: score.rank,
      total: score.total,
      intent: getComparedToAverageClassStyle(
        score.average ? score.score - score.average : undefined
      ),
    };
  });
  const ind = assD.findIndex((o) => o.stayStart === selectedAssessment);
  d[ind] = {
    scores: trends,
    selectedAss: moment(currAssess.stayStart).format('DD MMM YYYY'),
  };
  setBenchmarkingScores(d);

  for (const index in filterAssess) {
    if (filterAssess[index]) {
      const assessment = filterAssess[index];
      let dataD: any = [];
      const OfflineData = await GetAllDataByIndexedDB(
        `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/benchmark-by-category?&brandId=${selectedBrand}&toDate=${assessment.stayStart}&isClientApp=true${performanceClassification ? '&performanceClassifier=' + performanceClassification : ''}`,
        selectedHotel
      );
      if (OfflineData) {
        dataD = OfflineData;
      } else {
        const { data } = await axiosInstance.get(
          `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/benchmark-by-category?&brandId=${selectedBrand}&toDate=${assessment.stayStart}&isClientApp=true${performanceClassification ? '&performanceClassifier=' + performanceClassification : ''}`
        );
        dataD = data;
        CreateDataByIndexedDB(
          `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/benchmark-by-category?&brandId=${selectedBrand}&toDate=${assessment.stayStart}&isClientApp=true${performanceClassification ? '&performanceClassifier=' + performanceClassification : ''}`,
          data,
          selectedHotel
        );
      }

      const { scores } = dataD;
      const trends = scores.map((score) => {
        return {
          name: score.categoryName,
          val: score.score,
          lineVal: score.rank,
          total: score.total,
          intent: getComparedToAverageClassStyle(
            score.average ? score.score - score.average : undefined
          ),
        };
      });
      const ind = assD.findIndex((o) => o.id === assessment.id);
      d[ind] = {
        scores: trends,
        selectedAss: moment(assessment.stayStart).format('DD MMM YYYY'),
      };
      setBenchmarkingScores(d);
      response.push({
        scores: trends,
        selectedAss: moment(assessment.stayStart).format('DD MMM YYYY'),
      });
    }
  }
  setSliderLoader(false);
  return response;
};

export const assessments = async () => {
  const { selectedHotel, selectedClient } = userHotelDetails();
  const { data } = await axiosInstance.get(`${Env.API_URL}/customerHotel/${selectedHotel}/assessments?selectedClient=${selectedClient}`);
  return data;
};

export const getCustomScores = async (hotelId: number, assessmentType?: AssessmentTypes) => {
  const assessmentTypeParam = assessmentType ? `&assessmentType=${assessmentType}` : '';
  const apiUrl = `${Env.API_URL}/customer/hotel-reports-filter/${hotelId}/availableScoreTypes?${assessmentTypeParam}`;
  const { data } = await axiosInstance.get<ICustomScoresResponse>(apiUrl);
  return data.results;
};

export const benchmarkCustom = async (
  customNumber,
  selectedAssessment,
  setBenchmarkingScores,
  benchmarkingScores,
  setSliderLoader,
  assessments,
  performanceClassification?: string
) => {
  const { selectedHotel, selectedBrand } = userHotelDetails();
  if (performanceClassification && performanceClassification === 'all') {
    performanceClassification = undefined;
  }
  const response: any[] = []; // missing type
  const d = [...benchmarkingScores]; // variable name needs to be descriptive and set a proper type
  const assD = [...assessments]; // variable name needs to be descriptive and set a proper type
  reverse(assD);
  setSliderLoader(true);
  const currAssess = assD.find((o) => o.stayStart === selectedAssessment); // variable name needs to be descriptive and set a proper type
  const filterAssess = assD.filter((o) => o.stayStart != selectedAssessment); // variable name needs to be descriptive and set a proper type

  let dataD: any = []; // variable name needs to be descriptive and set a proper type
  const OfflineData = await GetAllDataByIndexedDB(
    `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/custom-benchmark-by-category?&brandId=${selectedBrand}&scoreNumber=${customNumber}&toDate=${currAssess.stayStart}&isClientApp=true${performanceClassification ? '&performanceClassifier=' + performanceClassification : ''}`,
    selectedHotel
  );
  if (OfflineData) {
    dataD = OfflineData;
  } else {
    const { data } = await axiosInstance.get(
      `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/custom-benchmark-by-category?&brandId=${selectedBrand}&scoreNumber=${customNumber}&toDate=${currAssess.stayStart}&isClientApp=true${performanceClassification ? '&performanceClassifier=' + performanceClassification : ''}`
    );
    dataD = data;
    CreateDataByIndexedDB(
      `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/custom-benchmark-by-category?&brandId=${selectedBrand}&scoreNumber=${customNumber}&toDate=${currAssess.stayStart}&isClientApp=true${performanceClassification ? '&performanceClassifier=' + performanceClassification : ''}`,
      data,
      selectedHotel
    );
  }

  const { scores } = dataD;
  const trends = scores.map((score) => {
    return {
      name: score.categoryName,
      val: score.score,
      lineVal: score.rank,
      total: score.total,
      intent: 'success',
    };
  });
  const ind = assD.findIndex((o) => o.stayStart === selectedAssessment);
  d[ind] = {
    scores: trends,
    selectedAss: moment(currAssess.stayStart).format('DD MMM YYYY'),
  };
  setBenchmarkingScores(d);
  for (const index in filterAssess) {
    if (filterAssess[index]) {
      const assessment = filterAssess[index];

      try {
        const OfflineData = await GetAllDataByIndexedDB(
          `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/custom-benchmark-by-category?&brandId=${selectedBrand}&scoreNumber=${customNumber}&toDate=${assessment.stayStart}&isClientApp=true${performanceClassification ? '&performanceClassifier=' + performanceClassification : ''}`,
          selectedHotel
        );
        if (OfflineData) {
          dataD = OfflineData;
        } else {
          const { data } = await axiosInstance.get(
            `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/custom-benchmark-by-category?&brandId=${selectedBrand}&scoreNumber=${customNumber}&toDate=${assessment.stayStart}&isClientApp=true${performanceClassification ? '&performanceClassifier=' + performanceClassification : ''}`
          );
          dataD = data;
          CreateDataByIndexedDB(
            `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/custom-benchmark-by-category?&brandId=${selectedBrand}&scoreNumber=${customNumber}&toDate=${assessment.stayStart}&isClientApp=true${performanceClassification ? '&performanceClassifier=' + performanceClassification : ''}`,
            data,
            selectedHotel
          );
        }
        const { scores } = dataD;
        const trends = scores.map((score) => {
          return {
            name: score.categoryName,
            val: score.score,
            lineVal: score.rank,
            total: score.total,
            intent: 'success',
          };
        });
        const ind = assD.findIndex((o) => o.id === assessment.id);
        d[ind] = {
          scores: trends,
          selectedAss: moment(assessment.stayStart).format('DD MMM YYYY'),
        };
        setBenchmarkingScores(d);
        response.push({
          scores: trends,
          selectedAss: moment(assessment.stayStart).format('DD MMM YYYY'),
        });
      } catch (err) {
        continue;
      }
    }
  }
  setSliderLoader(false);
  return response;
};

export const hotelScoresByDepartment = async (
  assessments,
  selectedAssessment,
  setBenchmarkingScores,
  benchmarkingScores,
  setSliderLoader,
  setDepartmentUser,
  selectedCompset,
  performanceClassification?: string
) => {
  const { selectedHotel, selectedBrand } = userHotelDetails();
  if (performanceClassification && performanceClassification === 'all') {
    performanceClassification = undefined;
  }
  setSliderLoader(true);
  const standard = 'LQA';
  let condition = '';
  if (performanceClassification) {
    condition += `&performanceClassification=${performanceClassification}`;
  }
  let compset = '';
  if (selectedCompset !== '0') {
    compset = '&compSetNumber=' + selectedCompset;
  }
  const response: any[] = [];
  const d = [...benchmarkingScores];
  const assD = [...assessments];
  reverse(assD);
  const currAssess = assD.find((o) => o.stayStart === selectedAssessment);
  const filterAssess = assD.filter((o) => o.stayStart != selectedAssessment);
  let dataX: any = [];
  const OfflineData = await GetAllDataByIndexedDB(
    `${Env.API_URL}/customer/hotel-benchmarking/${selectedHotel}/benchmarks?&view=category&hotelTypes=City&hotelTypes=Resort&standard=${standard}&brandId=${selectedBrand}&toDate=${selectedAssessment}${condition}${compset}&isClientApp=true-Dashboard`,
    selectedHotel
  );
  if (OfflineData) {
    dataX = OfflineData;
  } else {
    const { data: dataD } = await axiosInstance.get(
      `${Env.API_URL}/customer/hotel-benchmarking/${selectedHotel}/benchmarks?&view=category&hotelTypes=City&hotelTypes=Resort&standard=${standard}&brandId=${selectedBrand}&toDate=${selectedAssessment}${condition}${compset}&isClientApp=true`
    );
    dataX = dataD.data;
    CreateDataByIndexedDB(
      `${Env.API_URL}/customer/hotel-benchmarking/${selectedHotel}/benchmarks?&view=category&hotelTypes=City&hotelTypes=Resort&standard=${standard}&brandId=${selectedBrand}&toDate=${selectedAssessment}${condition}${compset}&isClientApp=true-Dashboard`,
      dataD.data,
      selectedHotel
    );
  }
  const data = dataX;
  const benchMarkByCategoryArr: any = [];
  const count = data.filter((o) => o[1] === 'category').length;
  if (count === 1) {
    const department = data.filter((o) => o[1] === 'category')[0][2];
    setItem('department', department);
    setDepartmentUser(department);
  } else {
    setItem('department', 'All');
    setDepartmentUser(undefined);
  }
  if (count > 1) {
    for (let i = 0; i < data.length; i++) {
      if (data[i][1] === 'category') {
        if (data[i][1] === 'category' || data[i][1] === 'overall') {
          const bMark = {
            name: data[i][2],
            val: data[i][8],
            lineVal: data[i][4],
            total: data[i][5],
            intent: getComparedToAverageClassStyle(
              data[i][6] ? data[i][8] - data[i][6] : undefined
            ),
          };
          benchMarkByCategoryArr.push(bMark);
        }
      }
    }
  } else {
    for (let i = 0; i < data.length; i++) {
      if (data[i][1] === 'subCategory') {
        if (data[i][1] === 'subCategory' || data[i][1] === 'overall') {
          const bMark = {
            name: data[i][2],
            val: data[i][8],
            lineVal: data[i][4],
            total: data[i][5],
            intent: getComparedToAverageClassStyle(
              data[i][6] ? data[i][8] - data[i][6] : undefined
            ),
          };
          benchMarkByCategoryArr.push(bMark);
        }
      }
    }
  }
  const ind = assD.findIndex((o) => o.stayStart === selectedAssessment);
  d[ind] = {
    scores: benchMarkByCategoryArr,
    selectedAss: moment(currAssess.stayStart).format('DD MMM YYYY'),
  };
  setBenchmarkingScores(d);
  for (const index in filterAssess) {
    if (filterAssess[index]) {
      const assessment = filterAssess[index];

      try {
        let dataZ: any = [];
        const OfflineDataBenchMarking = await GetAllDataByIndexedDB(
          `${Env.API_URL}/customer/hotel-benchmarking/${selectedHotel}/benchmarks?&view=category&hotelTypes=City&hotelTypes=Resort&standard=${standard}&brandId=${selectedBrand}&toDate=${assessment.stayStart}${condition}&isClientApp=true-Dashboard`,
          selectedHotel
        );
        if (OfflineDataBenchMarking) {
          dataZ = OfflineDataBenchMarking;
        } else {
          const { data: dataD } = await axiosInstance.get(
            `${Env.API_URL}/customer/hotel-benchmarking/${selectedHotel}/benchmarks?&view=category&hotelTypes=City&hotelTypes=Resort&standard=${standard}&brandId=${selectedBrand}&toDate=${assessment.stayStart}${condition}&isClientApp=true`
          );
          dataZ = dataD.data;
          CreateDataByIndexedDB(
            `${Env.API_URL}/customer/hotel-benchmarking/${selectedHotel}/benchmarks?&view=category&hotelTypes=City&hotelTypes=Resort&standard=${standard}&brandId=${selectedBrand}&toDate=${assessment.stayStart}${condition}&isClientApp=true-Dashboard`,
            dataD.data,
            selectedHotel
          );
        }
        const data = dataZ;
        const benchMarkByCategoryArr: any = [];
        if (count > 1) {
          for (let i = 0; i < data.length; i++) {
            if (data[i][1] === 'category' || data[i][1] === 'overall') {
              const bMark = {
                name: data[i][2],
                val: data[i][8],
                lineVal: data[i][4],
                total: data[i][5],
                intent: getComparedToAverageClassStyle(
                  data[i][6] ? data[i][8] - data[i][6] : undefined
                ),
              };
              benchMarkByCategoryArr.push(bMark);
            }
          }
        } else {
          for (let i = 0; i < data.length; i++) {
            if (data[i][1] === 'subCategory' || data[i][1] === 'overall') {
              const bMark = {
                name: data[i][2],
                val: data[i][8],
                lineVal: data[i][4],
                total: data[i][5],
                intent: getComparedToAverageClassStyle(
                  data[i][6] ? data[i][8] - data[i][6] : undefined
                ),
              };
              benchMarkByCategoryArr.push(bMark);
            }
          }
        }
        const ind = assD.findIndex((o) => o.id === assessment.id);
        d[ind] = {
          scores: benchMarkByCategoryArr,
          selectedAss: moment(assessment.stayStart).format('DD MMM YYYY'),
        };
        setBenchmarkingScores(d);
        response.push({
          scores: benchMarkByCategoryArr,
          selectedAss: moment(assessment.stayStart).format('DD MMM YYYY'),
        });
      } catch (err) {
        continue;
      }
    }
  }
  setSliderLoader(false);
  return response;
};

export const UploadFileRestriction = async () => {
  const { selectedHotel } = userHotelDetails();
  let dataD: any = [];
  const OfflineData = await GetAllDataByIndexedDB(
    `${Env.API_URL}/bootstrap/fileUploadRestrictions`,
    selectedHotel
  );
  if (OfflineData) {
    dataD = OfflineData;
  } else {
    const { data } = await axiosInstance.get(
      `${Env.API_URL}/bootstrap/fileUploadRestrictions`
    );
    dataD = data;
    CreateDataByIndexedDB(
      `${Env.API_URL}/bootstrap/fileUploadRestrictions`,
      data,
      selectedHotel
    );
  }
  return dataD;
};

export const overAllScoreAPI = async (selectedAssessment, selectedCompset) => {
  const { selectedHotel, selectedBrand } = userHotelDetails();
  let dataD: any = [];
  const OfflineData = await GetAllDataByIndexedDB(
    `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/overall-scores-data?&brandId=${selectedBrand}&toDate=${selectedAssessment}${selectedCompset === '0' ? '' : '&compSetNumber=' + selectedCompset}&isClientApp=true`,
    selectedHotel
  );
  if (OfflineData) {
    dataD = OfflineData;
  } else {
    const { data } = await axiosInstance.get(
      `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/overall-scores-data?&brandId=${selectedBrand}&toDate=${selectedAssessment}${selectedCompset === '0' ? '' : '&compSetNumber=' + selectedCompset}&isClientApp=true`
    );
    dataD = data;
    CreateDataByIndexedDB(
      `${Env.API_URL}/customer/hotel-dashboard/${selectedHotel}/overall-scores-data?&brandId=${selectedBrand}&toDate=${selectedAssessment}${selectedCompset === '0' ? '' : '&compSetNumber=' + selectedCompset}&isClientApp=true`,
      data,
      selectedHotel
    );
  }

  return dataD;
};
export const lqaCustomCompset = async () => {
  const { selectedHotel } = userHotelDetails();
  let dataD: any = [];
  const OfflineData = await GetAllDataByIndexedDB(
    `${Env.API_URL}/customer/hotel-benchmarking/${selectedHotel}/compSets?`,
    selectedHotel
  );
  if (OfflineData) {
    dataD = OfflineData;
  } else {
    const { data } = await axiosInstance.get(
      `${Env.API_URL}/customer/hotel-benchmarking/${selectedHotel}/compSets?`
    );
    dataD = data;
    CreateDataByIndexedDB(
      `${Env.API_URL}/customer/hotel-benchmarking/${selectedHotel}/compSets?`,
      data,
      selectedHotel
    );
  }
  return dataD;
};

export const CompetetingHotels = async (
  selectedCompset,
  selectedAssessment
) => {
  const { selectedHotel, selectedBrand } = userHotelDetails();

  let dataD: any = [];
  const OfflineData = await GetAllDataByIndexedDB(
    `${Env.API_URL}/customer/hotel-benchmarking/${selectedHotel}/comp-set?&brandId=${selectedBrand}&compSetNumber=${selectedCompset}&standard=LQA&toDate=${selectedAssessment}`,
    selectedHotel
  );
  if (OfflineData) {
    dataD = OfflineData;
  } else {
    const { data } = await axiosInstance.get(
      `${Env.API_URL}/customer/hotel-benchmarking/${selectedHotel}/comp-set?&brandId=${selectedBrand}&compSetNumber=${selectedCompset}&standard=LQA&toDate=${selectedAssessment}`
    );
    dataD = data;
    CreateDataByIndexedDB(
      `${Env.API_URL}/customer/hotel-benchmarking/${selectedHotel}/comp-set?&brandId=${selectedBrand}&compSetNumber=${selectedCompset}&standard=LQA&toDate=${selectedAssessment}`,
      data,
      selectedHotel
    );
  }
  return dataD;
};

export const departmentName = async () => {
  const { selectedHotel } = userHotelDetails();
  const apiUrl = `${Env.API_URL}/customerClientUser/departmentaccess`;
  let dataD: any = [];
  const OfflineData = await GetAllDataByIndexedDB(apiUrl, selectedHotel);
  if (OfflineData) {
    dataD = OfflineData;
  } else {
    const { data } = await axiosInstance.get(apiUrl);
    dataD = data;
    CreateDataByIndexedDB(apiUrl, data, selectedHotel);
  }
  return dataD;
};
